import React from 'react';
import randomstring from 'uuid/v4';
import ProcessApi from '../../api/ProcessApi';

class File extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    async handleChange(e) {
        this.props.onStart();

        // get the files
        let files = this.props.multiple ? [...e.target.files] : [e.target.files[0]];

        // Process each file
        var allFiles = [];
        for (const file of files) {
            const key = randomstring();

            let fileInfo = {
                name: file.name,
                type: file.type
                    ? file.type
                    : file.name.endsWith('.xls')
                    ? 'application/vnd.ms-excel'
                    : 'text/plain',
                size: file.size,
                link: file,
                comentario: file.name,
                key: key,
            };
            //1073741824

            const url = await ProcessApi.uploadFile(this.props.instance, this.props.field, fileInfo)
                .then((url) => {
                    allFiles.push({
                        comentario: fileInfo.comentario,
                        base: `${url}`,
                        link: `${url}/datos`,
                    });
                    if (allFiles.length === files.length) {
                        this.props.onDone(allFiles);
                    }
                    return url;
                })
                .catch((error) => {
                    console.log(error);
                    this.props.onError(error);
                });
            console.log(url);
        }
    }

    render() {
        return (
            <input
                type="file"
                onChange={this.handleChange.bind(this)}
                multiple={this.props.multiple}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                        application/vnd.ms-excel,
                        application/vnd.ms-powerpoint,
                        application/msword,
                        application/pdf,
                        application/zip,
                        video/mpeg"
                data-max-size="10013756"
            />
        );
    }
}

File.defaultProps = {
    multiple: false,
};

export default File;



// WEBPACK FOOTER //
// ./src/components/inputs/File.js